export const nosotrosMainBanner = [
    {
        image: './assets/imgs/nosotros/banner/fondo.png',
        color: '#EA0029',
        text: '<span>NOSOTROS</span>',
      }

];

export const nosotrosMainBannerEn = [
    {
        image: './assets/imgs/nosotros/banner/fondo.png',
        color: '#EA0029',
        text: 'ABOUT US',
      }
];